<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" slim>
    <form @submit.prevent="handleSubmit(saveUser)" class="justify-content-between col-lg-12 py-3">
      <div class="form-row align-items-center py-3">
        <TextInputField
            class="form-group col-lg-6" v-model="firstName"
            labelText="voornaam" required/>
        <TextInputField
            class="form-group col-lg-6" v-model="lastName"
            labelText="achternaam" required/>
      </div>

      <div class="form-row align-items-center py-3">
        <TextInputField
            class="form-group col-lg-8" v-model="email"
            labelText="email" required
            email/>
        <NumberInputField
            class="form-group col-lg-4" v-model="partTimePercentage"
            labelText="deeltijds percentage" required
            minValue="50" maxValue="100"/>
      </div>

      <div class="form-row align-items-center py-3">
        <NumberInputField
            class="form-group col-lg-4" v-model="sickDayHours"
            step=".1" labelText="duur absentiedag"
            required
            minValue="0" maxValue="24"/>
        <NumberInputField
            class="form-group col-lg-4" v-model="employeeNr"
            labelText="werknemersnummer"
            minValue="0" maxValue="9999999"/>
        <DropDownInputField v-if="hrEmployers.length > 1"
            class="form-group col-lg-4" v-model="selectedHREmployer"
            labelText="HR werkgever" required
            :dropdown-elements="hrEmployers"/>
      </div>

      <div class="form-row align-items-center py-3">
        <DateInputField
            class="col-lg-4"
            v-model="employmentStartDate"
            label-text="Start datum" required/>
        <div class="col-lg-4">
          <ValidationProvider
              tag="div" class="form-check d-inline-block text-left"
              name="provider" rules="required"
              v-slot="{ errors }">
            <p class="mb-2">Provider</p>
            <div class="form-check">
              <input
                  class="form-check-input" type="radio"
                  id="google" value="GOOGLE"
                  v-model="provider"/>
              <label class="form-check-label" for="google">Google</label>
            </div>
            <div class="form-check">
              <input
                  class="form-check-input" type="radio"
                  id="apple" value="APPLE"
                  v-model="provider"/>
              <label class="form-check-label" for="apple">Apple</label>
            </div>
            <span class="text-red">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="col-lg-4">
          <ValidationProvider
              tag="div" rules="required"
              class="d-inline-block text-left" name="rollen"
              v-slot="{ errors }">
            <p class="mb-2">Rollen</p>
            <div class="form-check">
              <input
                  class="form-check-input" type="checkbox"
                  id="admin" value="ROLE_ADMIN"
                  v-model="roles"/>
              <label class="form-check-label" for="admin">Admin</label>
            </div>

            <div class="form-check">
              <input
                  class="form-check-input" type="checkbox"
                  id="user" value="ROLE_USER"
                  v-model="roles"/>
              <label class="form-check-label" for="user">Gebruiker</label>
            </div>
            <span class="text-red">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>

      <div class="form-row align-items-center py-3">
        <div class="input-group col-6">
          <button
              type="submit" :disabled="invalid"
              class="btn-basic btn-fill-pulse">
            Opslaan
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import TextInputField from "@/components/inputFields/TextInputField";
import NumberInputField from "@/components/inputFields/NumberInputField";
import DropDownInputField from "@/components/inputFields/DropDownInputField";
import DateInputField from "@/components/inputFields/DateInputField.vue";
import {toYearAndMonth} from "@/util/DateUtil";

export default {
  name: "CreateUserComponent",
  components: {
    DateInputField,
    DropDownInputField,
    NumberInputField,
    TextInputField,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      partTimePercentage: 100,
      sickDayHours: 7.6,
      employeeNr: undefined,
      provider: "GOOGLE",
      employmentStartDate: "",
      roles: [],
      selectedHREmployer: ""
    };
  },
  computed: {
    ...mapGetters({
      hrEmployers: "administrationUser/hrEmployers",
      isError: 'isError'
    })
  },
  created() {
    this.fetchHREmployers();
    this.initializeIfOnlyOneHREmployer();
  },
  methods: {
    ...mapActions("administrationUser", [
      'createUser',
      'fetchHREmployers',
    ]),
    initializeIfOnlyOneHREmployer() {
      this.hrEmployers.length === 1 ? this.selectedHREmployer = this.hrEmployers[0].id : this.selectedHREmployer = undefined;
    },
    saveUser() {
      const createUserDto = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        partTimePercentage: this.partTimePercentage,
        sickDayHours: this.sickDayHours,
        employeeNr: this.employeeNr,
        provider: this.provider,
        roles: this.roles,
        hrEmployerId: this.selectedHREmployer == "" && !this.selectedUserDetail.hrEmployer ? null : this.selectedHREmployer,
        employmentStartDate: this.employmentStartDate
      };
      this.createUser(createUserDto).then(() => {
        if (!this.isError) {
          this.$emit('userAdded');
        }
      });
    },
    getYearMonthAsString() {
      return toYearAndMonth(this.currentlySelectedMonth);
    },
  }
};
</script>
<style scoped>

.text-red {
  color: red;
}

</style>
